import axios from "axios"
import { API_BASE_URL } from "../config/apiConfig"
import { getToken } from "./auth"

const axiosClient = axios.create({
  baseURL: API_BASE_URL,
})

const axiosClientWithoutApiPrefix = axios.create({
  baseURL: "https://api.merrvesh.com/",
})

axiosClientWithoutApiPrefix.interceptors.request.use(
  config => {
    if (config.authRequired) {
      const token = getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axiosClient.interceptors.request.use(
  config => {
    if (config.authRequired) {
      const token = getToken()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }

    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default axiosClient
export { axiosClientWithoutApiPrefix }
